import * as React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Row } from "security-app/components/common/FormBaseStyles";
import useCurrentUser from "hooks/useCurrentUser";
const ICON_TYPES = {
  team: "group",
  user: "person"
};
const StyledIcon = styled(Icon)`
  width: 24px;
  vertical-align: middle;
`;
const AssigneeLabel = ({ assignee }) => {
  const currentUser = useCurrentUser();
  const isCurrentUser = currentUser.id === assignee.id;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledIcon, { name: ICON_TYPES[assignee.type], size: "xs" }), isCurrentUser ? `Me (${assignee.label})` : assignee.label);
};
const AssigneeCell = ({ assignee }) => /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "0.2rem" }, !assignee ? /* @__PURE__ */ React.createElement("span", null, "--") : /* @__PURE__ */ React.createElement(AssigneeLabel, { assignee }));
export default AssigneeCell;
